<template>
  <div>
    <b-sidebar
      id="notification_tray"
      right
      shadow
      no-header
      backdrop
      backdrop-variant="dark"
      width="320px"
      :visible="open"
      @hidden="$emit('close')"
    >
      <template #default="{ hide }">
        <div class="notif-wrapper">

          <!-- Header -->
          <div class="notif-header">
            <span class="notif-header__title">
              <i class="fas fa-bell mr-2"></i>Notifications
            </span>
            <div class="pointer" @click="hide()">
              <i class="fas fa-times"></i>
            </div>
          </div>

          <div v-if="loading.notifications" class="notif-empty">
            <i class="fas fa-atom fa-spin"></i>
          </div>

          <!-- Empty state -->
          <div v-else-if="!notifications.length" class="notif-empty">
            <i class="fas fa-bell-slash fa-2x mb-3"></i>
            <p class="mb-0">No notifications</p>
          </div>

          <!-- List -->
          <div v-else>
            <div
              v-for="item in notifications"
              :key="item.id"
              class="notif-item"
            >
              <div class="notif-item__avatar-wrap">
                <img :src="item.sender_avatar || 'https://media.iamconnected.com/profile_images/default.png'" class="notif-item__avatar" alt="" />
              </div>
              <div class="notif-item__content">
                <p class="notif-item__sender">{{ item.type === 'primary' ? 'iAMconnected' : item.sender_name }}</p>
                <p class="notif-item__text">{{ item.text }}</p>
                <div class="mt-2">
                  <button class="notif-action-btn" @click="handleAction(item, hide)">
                    <i :class="actionIcon(item)" class="mr-1"></i>{{ actionLabel(item) }}
                  </button>
                </div>
              </div>
              <span v-if="!item.is_read" class="notif-item__unread-dot"></span>
            </div>
          </div>

        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import axios from '@/axios';

export default {
  name: 'NotificationTray',
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.getNotifications()
  },
  data() {
    return {
      loading: { notifications: false },
      notifications: [],
      sessionUnreadIds: [],
    };
  },
  methods: {
    async getNotifications() {
      this.loading.notifications = true
      this.notifications = await axios('notifications?mark-read=1').then(resp => resp.data || [])
      this.loading.notifications = false
    },

    dotClass(item) {
      // @todo do we need this?
      // for green it show like user is online, he might not be online
      const map = {
        connection_request:  'notif-item__dot--green',
        connection_accepted: 'notif-item__dot--purple',
        processing_request:  'notif-item__dot--gold',
        chat:                'notif-item__dot--blue',
        reflection_shared:   'notif-item__dot--gold',
        reflection_comment:  'notif-item__dot--blue',
        thanks:              'notif-item__dot--green',
      };
      return map[item.type] || 'notif-item__dot--gold';
    },

    actionLabel(item) {
      const map = {
        connection_request:  'View Request',
        connection_accepted: 'View Community',
        processing_request:  'Respond',
        chat:                'Open Chat',
        reflection_shared:   'View Reflection',
        reflection_comment:  'View Comment',
        thanks:              'Open Chat',
      };
      if (map[item.type]) return map[item.type];
      if (item.link && item.link.includes('chatbox')) return 'Open Chat';
      return 'View';
    },

    actionIcon(item) {
      const map = {
        connection_request:  'fas fa-user-plus',
        connection_accepted: 'fas fa-users',
        processing_request:  'fas fa-hands-helping',
        chat:                'fas fa-comment-dots',
        reflection_shared:   'fas fa-share-alt',
        reflection_comment:  'fas fa-comment-dots',
        thanks:              'fas fa-comment-dots',
      };
      if (map[item.type]) return map[item.type];
      if (item.link && item.link.includes('chatbox')) return 'fas fa-comment-dots';
      return 'fas fa-arrow-right';
    },

    handleAction(item, hide) {
      // @todo do we need to make this call?
      axios({
        url: 'notificationsClose',
        params: { id: item.id },
      }).finally(() => {
        hide();
        if (item.type === 'processing_request') {
          this.$root.$emit('show-processing-request', item.related_record_id);
        } else if (item.type === 'thanks') {
          const chatLink = item.link || (item.sender_id ? `/chatbox/${item.sender_id}` : '/dashboard');
          this.$router.push(chatLink).catch(() => {});
        } else {
          const link = item.link || '/dashboard';
          const target = link.includes('chatbox')
            ? link.split('?')[0] + '?t=' + Date.now()
            : link;
          this.$router.push(target).catch(() => {});
        }
      });
    },

    formatTime(dateStr) {
      if (!dateStr) return '';
      const diffMins = Math.floor((Date.now() - new Date(dateStr)) / 60000);
      if (diffMins < 1)  return 'Just now';
      if (diffMins < 60) return `${diffMins}m ago`;
      const diffHrs = Math.floor(diffMins / 60);
      if (diffHrs < 24)  return `${diffHrs}h ago`;
      return `${Math.floor(diffHrs / 24)}d ago`;
    },
  },
};
</script>

<style>
/* Tray wrapper — matches menu_wrapper style */
#notification_tray .b-sidebar-body {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  height: 100vh;
  overflow-y: auto;
}

#notification_tray .b-sidebar-body::-webkit-scrollbar { width: 4px; }
#notification_tray .b-sidebar-body::-webkit-scrollbar-thumb {
  background: rgba(209,175,96,0.4);
  border-radius: 4px;
}

.notif-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

/* Header — matches menu_header style */
.notif-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background-color: #fff;
  border-bottom: 1px solid rgba(209,175,96,0.3);
}

.notif-header__count {
  display: inline-block;
  background: rgba(209,175,96,0.15);
  color: #b3944b;
  border: 1px solid rgba(209,175,96,0.4);
  border-radius: 12px;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 1px 8px;
  margin-left: 6px;
  vertical-align: middle;
}

.notif-header__title {
  font-weight: 700;
  font-size: 1rem;
  color: #d1af60;
  letter-spacing: 0.3px;
}

/* Empty */
.notif-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-height: 260px;
  color: #bbb;
  font-size: 0.9rem;
}

/* Item */
.notif-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(209,175,96,0.12);
  position: relative;
  transition: background 0.15s;
}
.notif-item:hover { background: rgba(209,175,96,0.1); }

/* Avatar */
.notif-item__avatar-wrap { position: relative; flex-shrink: 0; }
.notif-item__avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid rgba(209,175,96,0.3);
  display: block;
}

.notif-item__dot {
  position: absolute;
  bottom: 1px; right: 1px;
  width: 11px; height: 11px;
  border-radius: 50%;
  border: 2px solid #fff;
  background: #d1af60;
}
.notif-item__dot--green  { background: #10b981; }
.notif-item__dot--purple { background: #8b5cf6; }
.notif-item__dot--gold   { background: #d1af60; }
.notif-item__dot--blue   { background: #3b82f6; }

/* Content */
.notif-item__content { flex: 1; min-width: 0; }
.notif-item__sender {
  font-weight: 700;
  font-size: 0.82rem;
  color: #333;
  margin: 0 0 2px;
}
.notif-item__text {
  font-size: 0.8rem;
  color: #555;
  margin: 0 0 3px;
  line-height: 1.4;
}
.notif-item__time {
  font-size: 0.7rem;
  color: #aaa;
  display: block;
}

/* Action button — matches gold theme */
.notif-action-btn {
  background: transparent;
  border: 1px solid #d1af60;
  color: #d1af60;
  border-radius: 20px;
  font-size: 0.75rem;
  padding: 3px 12px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.15s;
}
.notif-action-btn:hover {
  background: #d1af60;
  color: #fff;
}

/* Unread red dot */
.notif-item__unread-dot {
  position: absolute;
  top: 14px; right: 12px;
  width: 8px; height: 8px;
  border-radius: 50%;
  background: #e74c3c;
}
</style>
